"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ONGOING_DEPRECATED: 'Ongoing',
    ONGOING: 'Ongoing or Past',
    POTENTIAL: 'Potential',
};
//# sourceMappingURL=ecActivityType.js.map